/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OfferOutStatus
 */
export interface OfferOutStatus {
    /**
     * 
     * @type {string}
     * @memberof OfferOutStatus
     */
    statusCode: string;
    /**
     * 
     * @type {number}
     * @memberof OfferOutStatus
     */
    offerId: number;
    /**
     * 
     * @type {Date}
     * @memberof OfferOutStatus
     */
    modificationDate: Date;
}

export function OfferOutStatusFromJSON(json: any): OfferOutStatus {
    return OfferOutStatusFromJSONTyped(json, false);
}

export function OfferOutStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): OfferOutStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'statusCode': json['statusCode'],
        'offerId': json['offerId'],
        'modificationDate': (new Date(json['modificationDate'])),
    };
}

export function OfferOutStatusToJSON(value?: OfferOutStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'statusCode': value.statusCode,
        'offerId': value.offerId,
        'modificationDate': (value.modificationDate.toISOString()),
    };
}


